import { useEffect } from 'react';

export const useSubmitOnEnterKey = ({ onSubmit }: { onSubmit: (event: KeyboardEvent) => void }) => {
  useEffect(() => {
    const submitOnEnter = (event: KeyboardEvent) => {
      if (event.key === 'Enter') onSubmit(event);
    };

    document.addEventListener('keyup', submitOnEnter);

    return () => {
      document.removeEventListener('keyup', submitOnEnter);
    };
  }, [onSubmit]);
};
